import axios from "axios";

const api = axios.create({
  // baseURL: process.env.REACT_APP_BACKEND_URL || "http://localhost:8080",
  // baseURL: "https://udbhav.ongc.co.in/api",
  baseURL: "https://udbhav2.ogesone.com/api",
  headers: {
    "Content-Type": "application/json",
  },
});

export default api;
